/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Empty_Cta_Create_CatalogInputs */

const cs_templates_empty_cta_create_catalog = /** @type {(inputs: Templates_Empty_Cta_Create_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit katalogovou šablonu`)
};

const en_templates_empty_cta_create_catalog = /** @type {(inputs: Templates_Empty_Cta_Create_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create catalog template`)
};

/**
* | output |
* | --- |
* | "Create catalog template" |
*
* @param {Templates_Empty_Cta_Create_CatalogInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_empty_cta_create_catalog = /** @type {((inputs?: Templates_Empty_Cta_Create_CatalogInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Empty_Cta_Create_CatalogInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_empty_cta_create_catalog(inputs)
	return cs_templates_empty_cta_create_catalog(inputs)
});